import React from "react";
import "./ModalCover.scss";

const ModalCover = (props) => {
  return (
    <div onClick={props.onClick} style={props.style} className="modal-cover">{props.children}</div>
  );
};

export default ModalCover;
